// extracted by mini-css-extract-plugin
export default {"benefits":"FxT2m","benefits-container":"s9ON5","benefits__item":"tOEBw"};